<template>
  <div :class="[$style.menu, { [$style.open]: isOpen }]">
    <div :class="$style.cross">
      <img @click="$emit('close')" src="/icons/common/cross-black.svg" alt="" />
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Id</div>
      <div :class="$style.input">
        <input type="text" :value="supervision.id" />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Дата</div>
      <div :class="$style.input">
        <input
          type="text"
          :value="
            supervision.start_date
              ?.substr(0, 10)
              ?.split('-')
              ?.reverse()
              ?.join('.')
          "
        />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Организ. (ID)</div>
      <div :class="$style.input">
        <input type="text" :value="supervision?.organization?.id" />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Работник (ID)</div>
      <div :class="$style.input">
        <input type="text" :value="supervision?.worker?.id" />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Наблюдатель (Id)</div>
      <div :class="$style.input">
        <input type="text" :value="supervision?.user?.id" />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Вр. начала наблюд. (план/факт)</div>
      <div :class="$style.input">
        <input
          type="text"
          :value="
            supervision?.planned_start_time
              ? supervision?.planned_start_time
              : '--:--:--' + ' / ' + supervision?.start_date?.substr(11, 8)
          "
        />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Вр. оконч. наблюд. (план/факт)</div>
      <div :class="$style.input">
        <input
          type="text"
          :value="
            (supervision?.planned_end_time
              ? supervision?.planned_end_time
              : '--:--:--') +
            ' / ' +
            (supervision.end_date?.substr(11, 8)
              ? supervision.end_date?.substr(11, 8)
              : '--:--:--')
          "
        />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Продолжительность наблюдения (план/факт)</div>
      <div :class="$style.input">
        <input
          type="text"
          :value="
            (supervision?.planned_delta
              ? supervision?.planned_delta
              : '--:--:--') +
            ' / ' +
            (supervision.delta ? supervision.delta : '--:--:--')
          "
        />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Сбой в ЕМИАС, мин</div>
      <div :class="$style.input">
        <input
          type="text"
          :value="supervision?.display_total_failure_delta || '--:--:--'"
        />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">
        Количество трудовых операций с превышением длительности
      </div>
      <div :class="$style.input">
        <input type="text" :value="supervision?.overtime_activities_count" />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">
        Количество трудовых операций, всего, число
      </div>
      <div :class="$style.input">
        <input type="text" :value="supervision?.analytics?.length" />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">
        Количество трудовых операций, не проверенных мною
      </div>
      <div :class="$style.input">
        <input type="text" :value="unverifiedAnalyticsCount" />
      </div>
    </div>
    <div :class="$style.field">
      <div :class="$style.title">Комментарий администратора</div>
      <div :class="$style.input">
        <input
          type="text"
          :value="adminCommentValue"
          @input="adminCommentValue = $event.target.value"
          @blur="saveAdminComment"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupervisionSidebar",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    supervision: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      adminCommentValue: "",
      originalAdminComment: "",
    };
  },
  watch: {
    supervision: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          const comment = newVal.admin_comment || "";
          this.adminCommentValue = comment;
          this.originalAdminComment = comment;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  emits: ["close", "saveAdminComment"],
  computed: {
    unverifiedAnalyticsCount() {
      return (
        this.supervision?.analytics?.filter((item) => !item.verified)?.length ||
        0
      );
    },
  },
  methods: {
    saveAdminComment() {
      if (this.supervision?.id) {
        // Сохраняем только если значение изменилось
        if (this.adminCommentValue !== this.originalAdminComment) {
          this.$emit("saveAdminComment", {
            id: this.supervision.id,
            admin_comment: this.adminCommentValue,
          });
          this.originalAdminComment = this.adminCommentValue;
        }
      }
    },
  },
};
</script>

<style lang="scss" module>
.menu {
  width: 0;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  height: 100vh;
  &.open {
    background-color: $bg-white;
    width: 32.75rem;
    flex: 0 0 32.75rem;
    padding: 1rem;
    overflow: auto;
    @include scrollbarY;
    .cross {
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
      margin: 0 0 1rem 0;
    }
    .field {
      border: 1px solid $gray-34;
      border-radius: 1rem;
      display: flex;
      padding: 1rem;
      gap: 0.75rem;
      margin: 0 0 1rem 0;
      &:last-child {
        margin: 0;
      }
      .title {
        font-weight: 700;
        flex: 0 0 18rem;
      }
      .input {
        width: 100%;
        input {
          outline: 0;
          border: none;
          text-align: right;
        }
      }
    }
  }
}
</style>

